import type {AddComponentTypeOptions, ComponentDefinitionDefined} from 'grapesjs';
import {FORM_ERROR_MESSAGE_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_ERROR_MESSAGE_TYPE = 'postermywall-error-message';
const FORM_TEXT_DATA_ATTR = 'data-is-pmw-form-text';

/**
 * Round-trip detection keys off the `id` attribute, NOT the usual `data-is-pmw-*` marker
 * every other component uses. The legacy form-maker wrote a unique id for this single
 * error-message node so the runtime JS could grab it via getElementById; matching by id
 * keeps the saved-html contract intact.
 */
function isPostermywallErrorMessageElement(el: HTMLElement): ComponentDefinitionDefined | undefined {
  if (typeof el.getAttribute !== 'function') {
    return undefined;
  }
  return el.getAttribute('id') === POSTERMYWALL_ERROR_MESSAGE_TYPE ? {type: POSTERMYWALL_ERROR_MESSAGE_TYPE} : undefined;
}

export const POSTERMYWALL_ERROR_MESSAGE: AddComponentTypeOptions = {
  isComponent: isPostermywallErrorMessageElement,
  model: {
    defaults: {
      tagName: 'div',
      highlightable: false,
      selectable: false,
      draggable: false,
      hoverable: false,
      badgable: false,
      copyable: false,
      toolbar: [],
      content: window.i18next.t('pmwjs_valid_email_address'),
      attributes: {
        'data-pmw-type': POSTERMYWALL_ERROR_MESSAGE_TYPE,
        [FORM_TEXT_DATA_ATTR]: '1',
        id: POSTERMYWALL_ERROR_MESSAGE_TYPE,
      },
      style: FORM_ERROR_MESSAGE_STYLES,
    },
  },
};
